
export function handleUserQuantityDefinitionCategoryUpdated(state, payload) {
    const { category } = payload;
    if (!category?.id) return state;
    const existing = state.categoriesById[category.id];
    if (!existing) return state;

    const updatedCategory = {
        ...existing,
        title: category.title ?? existing.title,
        isActive: category.is_active ?? existing.is_active,
    };

    const nodeId = `c${category.id}`;

    return {
        ...state,
        categoriesById: {
            ...state.categoriesById,
            [category.id]: updatedCategory,
        },
    };
}